import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDeepestFirstChildUrl, isCurrentPathInMenu } from "../until";
import { selectorMenu, selectorMenuIsReady } from "../store/slices/menuSlice";
import { selectorPermission } from "../store/slices/permissionSlice";

export default function ProtectedRoute() {
  const location = useLocation();

  const menuSlice = useSelector(selectorMenu);
  const permissionSlice = useSelector(selectorPermission);
  const isMenuReadySlice = useSelector(selectorMenuIsReady);

  const pathname = location.pathname;

  // ✅ 1. Chưa sẵn sàng → chưa chặn
  if (!isMenuReadySlice) {
    return null; // hoặc <Loading />
  }

  // ✅ 2. Case root "/"
  if (pathname === "/") {
    const urlPage = getDeepestFirstChildUrl(menuSlice, true);
    return <Navigate to={urlPage ?? "/unauthorized"} replace />;
  }

  // ✅ 3. Check permission
  const isAsset = isCurrentPathInMenu(menuSlice, permissionSlice, pathname);

  if (!isAsset) {
    return <Navigate to="/unauthorized" replace />;
  }

  // ✅ 4. Cho phép render route con
  return <Outlet />;
}
